import React from 'react'
import {Label, Media, Row,} from "reactstrap";
import Button from "reactstrap/es/Button";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import Badge from "reactstrap/es/Badge";

const propTypes = {};
let resourceStrings = new LocalizedStrings(resource_strings);

export default class NotificationItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    icon() {
        switch (this.props.item.type) {
            case "bd":
                return require("assets/img/icons/common/bd_gray.svg").default;
            case "booking":
                return require("assets/img/icons/common/phone_gray.svg").default;
            case "new_client":
                return require("assets/img/icons/common/person-gray.svg").default;
            case "unbooking":
                return require("assets/img/icons/common/cancellation_red.svg").default;
            case "task":
                return require("assets/img/icons/common/task_gray.svg").default;
            case "event":
                return require("assets/img/icons/common/task_gray.svg").default;
            case "reminder":
                return require("assets/img/icons/common/task_gray.svg").default;
            case "notification_exp_tickets":
                return require("assets/img/icons/common/notification_gary.svg").default;
            case "wix_new_ticket":
                return require("assets/img/icons/common/wix.svg").default;
            case "wix_new_student":
                return require("assets/img/icons/common/wix.svg").default;
            case "stripe_new_ticket":
                return require("assets/img/icons/common/ticket.svg").default;
            case "feedback":
                return require("assets/img/icons/common/good-feedback.svg").default;
            case "student_message":
                return require("assets/img/icons/common/mail.png");
            default:
                return require("assets/img/icons/common/notification_gary.svg").default;
        }
    }

    render() {
        this.localize();

        return (
            <>
            <div onClick={e => this.props.onNotificationSelected(e, this.props.item)}
                 style={{cursor: "pointer", display: "flex", flexFlow: "row", justifyContent: "space-between",  padding: 16}}>
                <div style={{paddingRight: 0, display: "flex", flexFlow: "row", justifyContent: "left", alignItems: "center"}}>
                    <img
                        width={16}
                        height={16}
                        alt="pm"
                        src={this.icon()}
                    />

                    <small style={{marginLeft: 16, fontWeight: 500}} className="overflow-hidden">{this.props.item.title}</small>
                </div>
                <i className="fa fa-arrow-circle-right" style={{marginRight: 10}}/>
            </div>
                <hr style={{backgroundColor: "light-gray", marginTop: 0, marginBottom: 0, marginLeft: 50, marginRight: 50}}/>
            </>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        resourceStrings.setLanguage(loc);
    }

    titleText() {
        if (this.props.item.title && this.props.item.title.length > 0) {
            return this.props.item.title ? this.props.item.title.substring(0, 30) : "..."
        } else if (this.props.item.body && this.props.item.body.length > 0) {
            return this.props.item.body ? this.props.item.body.substring(0, 30) : "..."
        } else return ""
    }
}

NotificationItem.propTypes = propTypes;